import { Text, Box, Flex, Grid, Table, TableContainer, useToken } from "@chakra-ui/react";
import React, { Fragment, useState } from "react";
import PrimaryButton from "../../components/themeComponents/PrimaryButton";
import OutlinedButton from "../../components/themeComponents/OutlinedButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { getPushTemplateList } from "../../Services/api";
import { OvalSpinner } from "../../components/Loaders";
import TableHead from "../Campaigns/components/TableHead";
import hexToRgba from "hex-to-rgba";
import PushTable from "./PushTable";
import WebPushPreview from "./WebPushPreview";
import Pagination from "../../components/Pagination"; // Import the generic Pagination component
import * as _ from "lodash";

export default function PushTemplateList() {
  const [mainColor] = useToken("colors", ["primary.main"]);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedTempMessage, setSelectedTempMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const templateListQuery = useQuery(
    ["templates", currentPage],
    async () => {
      const templateList = await getPushTemplateList(currentPage, pageSize);
      setTotalCount(templateList?.data?.count ?? 0);
      return templateList?.data?.items ?? [];
    },
    {
      staleTime: 0, // Ensure fresh data on page change
      retry: 1,
      enabled: true, // Always enabled
    }
  );

  return (
    <Fragment>
      <Box w="100%" overflow="hidden" height="100%">
        <Flex justifyContent="space-between">
          <Text as="b" fontSize="2xl">
            Push Templates
          </Text>
          <OutlinedButton
            width="10vw"
            borderRadius="8px"
            label={t("flows.build.own")}
            onClick={() => navigate("/push/create")}
          />
        </Flex>
        <Grid templateColumns="1fr 1fr" h="calc(100% - 50px)">
          <Box
            h="100%"
            overflow="hidden"
            bg="white"
            p={3}
            borderRight="1px solid"
            borderColor="gray.200"
          >
            <TableContainer
              mt={4}
              overflowY="auto"
              overflow="auto"
              height="calc(100% - 50px)"
            >
              {templateListQuery.isLoading && <OvalSpinner />}
              {templateListQuery.isError && (
                <Flex justifyContent="center" alignItems="center" py={10}>
                  <Text color="red.500">Error loading templates. Please try again.</Text>
                </Flex>
              )}
              {!templateListQuery.isLoading && !templateListQuery.isError && (
                <Table>
                  {templateListQuery?.data?.length > 0 ? (
                    <Fragment>
                      <TableHead headersProps={["Template Name", "Actions"]} />
                      <PushTable
                        previewData={selectedTempMessage}
                        setPreviewMsg={setSelectedTempMessage}
                        list={templateListQuery.data}
                      />
                    </Fragment>
                  ) : (
                    <Flex
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                      py={10}
                    >
                      <Text fontSize="lg" fontWeight="bold" color="gray.600">
                        No templates found.
                      </Text>
                    </Flex>
                  )}
                </Table>
              )}
              {!templateListQuery.isLoading && templateListQuery?.data?.length > 0 && (
                <Pagination
                  totalCount={totalCount}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  onPageChange={setCurrentPage}
                  isDisabled={templateListQuery.isLoading}
                />
              )}
            </TableContainer>
          </Box>
          <Box p={3}>
            {_.isEmpty(selectedTempMessage) && (
              <Box
                mb={3}
                display="flex"
                alignItems="center"
                justifyContent="center"
                w="100%"
                height="100%"
              >
                <Text>No Template is selected for preview.</Text>
              </Box>
            )}
            {!_.isEmpty(selectedTempMessage) && (
              <Box
                mb={3}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <Box width="90%">
                  <Box p={0} ml={3}>
                    <Text>Template Name: {selectedTempMessage.templateName}</Text>
                    <Text
                      overflow="hidden"
                      whiteSpace="nowrap"
                      textOverflow="ellipsis"
                      width="400px"
                      maxW="400px"
                    >
                      Status:{" "}
                      {JSON.parse(selectedTempMessage.templateStatus) ? "ACTIVE" : "ARCHIVED"}
                    </Text>
                  </Box>
                  <Box mt={5}>
                    <WebPushPreview formData={selectedTempMessage} />
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
      </Box>
    </Fragment>
  );
}